module.exports = __webpack_public_path__ + "img/listItem4.ca43d403.png";